export default "__VITE_ASSET__D8jY6yHZ__"